<template>
  <div class="page boss-page corrections-page">
    <van-nav-bar title="我的纠偏事项" left-arrow @click-left="$router.back()"/>
    <van-skeleton v-if="loading" title :row="8"/>
    <main v-else>
      <button v-for="item in items" :key="item.id" @click="$router.push({name:'EfficiencyCorrectionDetail',params:{id:item.id}})">
        <span><em :class="item.status">{{ label(item.status) }}</em><time>{{ date(item.createdAt) }}</time></span>
        <b>{{ item.title }}</b>
        <p>{{ item.rationale || (item.actions || []).join('；') }}</p>
        <van-icon name="arrow"/>
      </button>
      <van-empty v-if="!items.length" description="暂无纠偏事项"/>
    </main>
  </div>
</template>
<script>
import coreapi from '@/utils/coreapi';

export default {
  data() {
    return {items: [], loading: false}
  }, mounted() {
    this.load()
  }, activated() {
    this.load()
  }, methods: {
    async load() {
      this.loading = true;
      try {
        this.items = await coreapi.corrections()
      } catch (e) {
        this.$toast.fail(e.message)
      } finally {
        this.loading = false
      }
    }, label(v) {
      return {
        CONVEYED: '待回应',
        ACCEPTED: '已采纳',
        CHANGE_REQUESTED: '申请修改',
        DISPUTED: '有异议',
        IN_PROGRESS: '执行中',
        SUBMITTED: '待验收',
        VERIFIED: '已完成'
      }[v] || v
    }, date(v) {
      return v ? new Date(v).toLocaleDateString('zh-CN') : '--'
    }
  }
}
</script>
<style lang="less" scoped>@import '~@/assets/base.less';
@import '../boss/boss.less';

.page {
  min-height: 100vh;
  background: #f6f7fb
}

main {
  padding: .28rem
}

main > button {
  position: relative;
  width: 100%;
  margin-bottom: .16rem;
  padding: .28rem .72rem .28rem .28rem;
  text-align: left;
  background: #fff;
  border-radius: .16rem;
  box-shadow: 0 .05rem .2rem rgba(0, 0, 0, .06)
}

main > button > span {
  display: flex;
  justify-content: space-between;
  align-items: center
}

em {
  padding: .05rem .14rem;
  color: @color;
  background: #fff1f1;
  border-radius: .08rem;
  font-size: .22rem;
  font-style: normal
}

em.VERIFIED {
  color: #278e56;
  background: #e9f8ef
}

em.IN_PROGRESS, em.ACCEPTED {
  color: #9a651f;
  background: #fff4dc
}

time {
  color: #9a9caf;
  font-size: .22rem
}

b {
  display: block;
  margin-top: .16rem;
  font-size: .32rem
}

p {
  margin-top: .08rem;
  color: #777b90;
  font-size: .26rem;
  line-height: 1.5;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical
}

.van-icon {
  position: absolute;
  right: .26rem;
  top: 50%;
  transform: translateY(-50%);
  color: #aaa
}
.corrections-page { margin: 0; min-height: 100vh; background: #f6f7fb; padding-bottom: 1.7rem; }
.corrections-page /deep/ .van-nav-bar { margin: 0; width: 100%; height: 1.22667rem; border-radius: 0; background: linear-gradient(135deg,#351b1d,#c6282d); }
</style>



// WEBPACK FOOTER //
// src/views/efficiency/Corrections.vue